import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cuid from 'cuid';

import './item-modal.css';
import Modal from '../modal/modal';
import ResourceTypes, { translatedResourceTypes } from '../../utils/resource-types';
import digestCategories, { translatedDigestCategories } from '../../utils/digest-categories';
import { FileTypes, readFile, SelectFile } from '../file-uploader/file-uploader';
import { uploadFile } from '../section/section.actions';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import activityContentTypes, { translatedActivityContentTypes } from '../../utils/activity-content-types';

const emptyState = {
    type: ResourceTypes.VIDEO,
    title: '',
    url: '',
    category: '',
    text: '',
    id: '',
    init: '',
    end: '',
    activityContentType: activityContentTypes.JUST_TEXT,
    formError: '',
};

class ItemModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = { ...emptyState, ...props.item };
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
    }

    onChange({ target }) {
        this.setState({ [target.name]: target.value, formError: '' });
    }

    onTypeChange(event) {
        this.setState(emptyState);
        this.onChange(event);
    }

    async onSubmit(e) {
        e.preventDefault();
        if (this.state.type === ResourceTypes.ACTIVITY && this.props.hasActivity) {
            this.setState({ formError: true });
            return;
        }

        if (this.state.url && !verifyUrl(this.state.url)) {
            this.setState({ formError: true });
            return;
        }

        const toSubmit = Object.keys(this.state)
            .filter(item => this.state[item] !== '')
            .map(item => ({ [item]: this.state[item] }))
            .reduce((obj, field) => Object.assign(obj, field), {});

        if (toSubmit.type === ResourceTypes.FILE && toSubmit.file) {
            const fileAsArrayBuffer = await readFile(toSubmit.file);
            this.props.uploadFile(fileAsArrayBuffer, uri => {
                toSubmit.file = undefined;
                toSubmit.url = uri;
                this.props.updateSectionItem(toSubmit);
                this.props.onClose();
            }, FileTypes.PdfFile);
        } else {
            if (toSubmit.url && !toSubmit.url.includes('//')) {
                toSubmit.url = `https://${toSubmit.url}`;
            }
            if (toSubmit.type === ResourceTypes.ACTIVITY) {
                toSubmit.id = toSubmit.id || cuid();
            }
            this.props.updateSectionItem(toSubmit);
            this.props.onClose();
        }
    }

    closeModal = e => {
        e.preventDefault();
        this.props.onClose();
    }

    render() {
        const { type } = this.state;
        const hasUrl = [ResourceTypes.VIDEO, ResourceTypes.LINK, ResourceTypes.AUDIO].includes(type);
        return (
            <Modal {...this.props}>
                <div className='new-class-modal'>
                    <h4>Editar</h4>
                    <form>
                        <section className='new-class-modal-fields'>
                            <div className='inline-form-row'>
                                <label>Tipo</label>
                                <select onChange={this.onTypeChange} name='type' value={this.state.type}>
                                    {Object.keys(ResourceTypes)
                                        .map((type, idx) =>
                                            <option key={idx} value={type}>{translatedResourceTypes[type]}</option>)
                                    }
                                </select>
                            </div>
                            {hasUrl && this.renderLinkableForm()}
                            {type === ResourceTypes.FILE && this.renderFileForm()}
                            {type === ResourceTypes.DIGEST && this.renderDigestForm()}
                            {type === ResourceTypes.ACTIVITY && this.renderActivityForm()}
                            {type === ResourceTypes.LIVE_LESSON && this.renderLiveLessonForm()}
                            {this.state.formError &&
                            <span className='form-warning'>Url inválida</span>
                            }
                        </section>

                        <section className='new-class-modal-btns'>
                            <button className='cancel-btn' onClick={ this.closeModal }>Cancelar</button>
                            <button className='save-btn' onClick={this.onSubmit}>Salvar</button>
                        </section>
                    </form>
                </div>
            </Modal>
        );
    }

    renderLiveLessonForm() {
        const { init, end } = this.state;
        return (
            <React.Fragment>
                <div className='inline-form-row'>
                    <label>Título</label>
                    <input
                        onChange={this.onChange} name='title' value={this.state.title}
                        placeholder='Título'/>
                </div>
                <div className='inline-form-row'>
                    <label>Url</label>
                    <input
                        onChange={this.onChange} name='url' value={this.state.url}
                        placeholder='url'/>
                </div>
                <div className='inline-form-row'>
                    <label>Início*:</label>
                    <DatePicker
                        readOnly
                        minDate={moment()}
                        onChange={data => {
                            this.setState({ init: data.tz('America/Sao_Paulo').toISOString(true) });
                        }}
                        selected={init ? moment(init) : null}
                        showTimeSelect
                        timeFormat='HH:mm'
                        timeCaption='Hora'
                        timeIntervals={15}
                        dateFormat='LLL'
                        preventOpenOnFocus
                    />
                </div>
                <div className='inline-form-row'>
                    <label>Fim*:</label>
                    <DatePicker
                        readOnly
                        minDate={init ? moment(init) : moment()}
                        onChange={data => this.setState({ end: data.tz('America/Sao_Paulo').toISOString(true) })}
                        selected={end ? moment(end) : null}
                        showTimeSelect
                        timeFormat='HH:mm'
                        timeCaption='Hora'
                        timeIntervals={15}
                        dateFormat='LLL'
                        preventOpenOnFocus
                    />
                </div>
                <span className='information-item'>* Horário de brasília</span>
            </React.Fragment>
        );
    }

    renderLinkableForm() {
        return (
            <React.Fragment>
                <div className='inline-form-row'>
                    <label>Título</label>
                    <input
                        onChange={this.onChange} name='title' value={this.state.title}
                        placeholder='Título'/>
                </div>
                <div className='inline-form-row'>
                    <label>Url</label>
                    <input
                        onChange={this.onChange} name='url' value={this.state.url}
                        placeholder='url'/>
                </div>
                <div className='inline-form-row'>
                    <label>Descrição (opcional)</label>
                    <textarea onChange={this.onChange} name='text' value={this.state.text}/>
                </div>
            </React.Fragment>
        );
    }

    renderFileForm() {
        return (
            <React.Fragment>
                <div className='inline-form-row'>
                    <label>Título</label>
                    <input
                        onChange={this.onChange} name='title' value={this.state.title}
                        placeholder='Título'/>
                </div>
                <div className='inline-form-row'>
                    <label>Arquivo</label>
                    {this.state.url && !this.state.file && <a href={this.state.url}>Arquivo atual</a>}
                    {this.state.file && <span style={{ color: '#1da4fc' }}>{this.state.file.name}</span>}
                    {<SelectFile
                        accept={FileTypes.PdfFile}
                        onChange={file => this.onChange({ target: { name: 'file', value: file } })}
                    />}
                </div>
                <div className='inline-form-row'>
                    <label>Descrição (opcional)</label>
                    <textarea onChange={this.onChange} name='text' value={this.state.text}/>
                </div>
            </React.Fragment>
        );
    }

    renderActivityForm() {
        return (
            <React.Fragment>
                <div className='inline-form-row'>
                    <label>Tipo de conteúdo</label>
                    <select onChange={this.onChange} name='activityContentType' value={this.state.activityContentType}>
                        {Object.keys(activityContentTypes).map((ac, idx) =>
                            <option key={idx} value={activityContentTypes[ac]}>
                                {translatedActivityContentTypes[ac]}
                            </option>
                        )}
                    </select>
                </div>
                {this.state.formError &&
                    <span className='form-warning'>Só é permitida a adição de um item do tipo atividade</span>
                }
            </React.Fragment>
        );
    }

    renderDigestForm() {
        return (
            <React.Fragment>
                <div className='inline-form-row'>
                    <label>Título</label>
                    <input
                        onChange={this.onChange} name='title' value={this.state.title}
                        placeholder='Título'/>
                </div>
                <div className='inline-form-row'>
                    <label>Categoria</label>
                    <select onChange={this.onChange} name='category' value={this.state.category}>
                        {Object.keys(digestCategories)
                            .map((type, idx) =>
                                <option
                                    key={idx}
                                    value={type}>{translatedDigestCategories[type]}</option>)
                        }
                    </select>
                </div>
                <div className='inline-form-row'>
                    <label>Texto</label>
                    <textarea
                        onChange={this.onChange} name='text' value={this.state.text}
                        placeholder='Texto'/>
                </div>
            </React.Fragment>
        );
    }
}

const verifyUrl = url => {
    const re = RegExp('^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&\'\\(\\)\\*\\+,;=.]+$');
    return url ? url.match(re) : true;
};

export default connect(null, dispatch => bindActionCreators({ uploadFile }, dispatch),)(ItemModal);



// WEBPACK FOOTER //
// ./src/components/item-modal/item-modal.js